export enum PaymentLinkStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum PaymentLinkAmountMode {
  FIXED = "FIXED",
  PAYER_CHOOSES = "PAYER_CHOOSES",
}

export enum PaymentLinkType {
  ONE_TIME = "ONE_TIME",
  SUBSCRIPTION = "SUBSCRIPTION",
}

export enum PaymentLinkSuccessType {
  MESSAGE = "MESSAGE",
  REDIRECT = "REDIRECT",
}

export enum PaymentLinkPaymentStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  REFUNDED = "REFUNDED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  CANCELED = "CANCELED",
}

export enum PaymentLinkAvailability {
  AVAILABLE = "AVAILABLE",
  INACTIVE = "INACTIVE",
  EXPIRED = "EXPIRED",
}

export enum PaymentLinkDrawerType {
  Create = "Create",
  Edit = "Edit",
  Details = "Details",
}
